// extracted by mini-css-extract-plugin
export var dividerContainer = "_7m-0";
export var line = "_7m-1";